import { type PropType } from 'vue';
import { UPDATE_MODEL_VALUE } from '../../constants';
import type { TooltipPlacement } from '../tooltip/tooltip';

export interface ChipsBoxProps {
    modelValue: string[];
    space?: number[];
    max?: number;
    closable?: boolean;
    tooltipMaxWidth?: string;
    tooltipPlacement?: TooltipPlacement;
}

export const chipsBoxProps = {
    modelValue: {
        type: [String, Array] as PropType<ChipsBoxProps['modelValue']>,
        default: undefined,
        required: false,
    },
    space: {
        type: Array as PropType<ChipsBoxProps['space']>,
        default: () => [5, 5],
        required: false,
    },
    max: {
        type: Number as PropType<ChipsBoxProps['max']>,
        default: undefined,
        required: false,
    },
    closable: {
        type: Boolean as PropType<ChipsBoxProps['closable']>,
        default: true,
        required: false,
    },
    tooltipMaxWidth: {
        type: String as PropType<ChipsBoxProps['tooltipMaxWidth']>,
        default: '500px',
        required: false,
    },
    tooltipPlacement: {
        type: String as PropType<ChipsBoxProps['tooltipPlacement']>,
        default: 'auto',
        required: false,
    },
};

export const chipsBoxEmits = {
    [UPDATE_MODEL_VALUE]: (event: string[]) => event,
    close: (event: { chip: string; index: number }) => event,
};
